import { getCommonSettingsData } from 'store/selectors';

export const selectMetaData = (state) => getCommonSettingsData(state).meta;
export const selectRequestUrl = (state) => new URL(selectMetaData(state).requestUrl);
export const selectRequestUrlOrigin = (state) => selectRequestUrl(state).origin;
export const selectRequestUrlPath = (state) => selectRequestUrl(state).pathname;
export const selectRequestUrlSearch = (state) => selectRequestUrl(state).search;
export const selectIsShopMainPage = (state) => selectRequestUrlPath(state) === '/shop/';
export const selectIsShopCatalogPage = (state) => selectRequestUrlPath(state)?.includes('catalog');
export const selectIsShopProductPage = (state) => selectRequestUrlPath(state)?.includes('details');
export const selectIsShopObzoryPage = (state) => selectRequestUrlPath(state)?.includes('obzory');
export const selectIsSearchInShop = (state) => selectRequestUrlPath(state)?.includes('search');
